import * as _ from "lodash"
import {ISearchRequest, PASearch} from "../PA.Core/PASearch";


export interface IHierarchyScope {
    wbMDSetId?: number
    // Enterprise Scope
    wbCompanyId?: number | number[],
    wbSalesOrgId?: number | number[],
    wbSalesAreaId?: number | number[],
}

export interface IEntityPath {
    wbHierarchyId: number,
    HierarchyId: string,
    HierarchyName: string,
    wbHierTargetId: number,

    SourceLevelId: number,
    SourceDepth: number,
    SourceWbEntityId: number,

    TargetLevelId: number,
    TargetDepth: number,
    TargetWbEntityId: number,

    Direction: string
}

const vWB_Hierarchy_EntityMap_SA = PASearch.createSimpleSchema(
    ['ENTITY_DIMENSION', 'HIERARCHY_ID', 'HIERARCHY_NAME',
        'LEVEL_ID_SOURCE', 'ENTITY_ID_SOURCE', 'ENTITY_NAME_SOURCE',
        'LEVEL_ID_TARGET', 'ENTITY_ID_TARGET', 'ENTITY_NAME_TARGET',
        'DIRECTION'],
    ['WB_HIERARCHY_ID', 'WB_MDSET_ID', 'TARGET_WB_ID',
        'LEVEL_DEPTH_SOURCE', 'LEVEL_DEPTH_TARGET', 'WB_ENTITY_ID_SOURCE', 'WB_ENTITY_ID_TARGET',
        'WB_SALESAREA_ID', 'WB_SALESORG_ID', 'WB_COMPANY_ID'])

export class HierarchyUsage
{


    async getSourceEntityPaths(wbEntityId_Source: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        return await this.getPaths(wbEntityId_Source, undefined, scope)
    }

    async getEntityPaths(wbEntityId_Source: number, wbEntityId_Target: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        return await this.getPaths(wbEntityId_Source, wbEntityId_Target, scope)
    }

    private async getPaths(wbEntityId_Source: number, wbEntityId_Target: number, scope: IHierarchyScope): Promise<IEntityPath[]> {
        let opts = scope || {}
        let req: ISearchRequest = {
            model: 'vWB_Hierarchy_EntityMap_SA',
            distinct: ['WB_HIERARCHY_ID', 'HIERARCHY_ID', 'HIERARCHY_NAME', 'ENTITY_DIMENSION', 'TARGET_WB_ID',
                'LEVEL_ID_SOURCE', 'ENTITY_ID_SOURCE',
                'LEVEL_ID_TARGET', 'ENTITY_ID_TARGET',
                'DIRECTION', 'LEVEL_DEPTH_SOURCE', 'LEVEL_DEPTH_TARGET', 'WB_ENTITY_ID_SOURCE', 'WB_ENTITY_ID_TARGET'],
            fields: vWB_Hierarchy_EntityMap_SA,
            where: {}
        }

        function createNumberCnd(q: any, fieldName: string, value: any){
            switch(true){
                case _.isUndefined(value):
                    return
                case _.isArray(value):
                    q[fieldName] = {inq: value}
                    return
                case _.isNumber(value):
                    q[fieldName] = value
                    return
            }
        }
        createNumberCnd(req.where, 'WB_MDSET_ID', opts.wbMDSetId)
        createNumberCnd(req.where, 'WB_COMPANY_ID', opts.wbCompanyId)
        createNumberCnd(req.where, 'WB_SALESORG_ID', opts.wbSalesOrgId)
        createNumberCnd(req.where, 'WB_SALESAREA_ID', opts.wbSalesAreaId)
        if(wbEntityId_Source > 0)
            createNumberCnd(req.where, 'WB_ENTITY_ID_SOURCE', wbEntityId_Source)
        if(wbEntityId_Target > 0)
            createNumberCnd(req.where, 'WB_ENTITY_ID_TARGET', wbEntityId_Target)

        let results = await PASearch.findByRequest(req)
        let rv: IEntityPath[] = []

        _.forEach(results, (row: any) => {
            rv.push({
                wbHierarchyId: row.WB_HIERARCHY_ID,
                HierarchyId: row.HIERARCHY_ID,
                HierarchyName: row.HIERARCHY_NAME,
                wbHierTargetId: row.TARGET_WB_ID,

                SourceLevelId: row.LEVEL_ID_SOURCE,
                SourceDepth: row.LEVEL_DEPTH_SOURCE,
                SourceWbEntityId: row.WB_ENTITY_ID_SOURCE,

                TargetLevelId: row.LEVEL_ID_TARGET,
                TargetDepth: row.LEVEL_DEPTH_TARGET,
                TargetWbEntityId: row.WB_ENTITY_ID_TARGET,

                Direction: row.DIRECTION
            })
        })

        return rv
    }

}